import { useMemo } from 'react';

import type { AssetDto } from 'api/generated/schemas/assetDto';

import type { AdminPatchClientFileArgs, AdminUploadClientFileArgs } from 'hooks/client-asset-api';
import {
  adminPatchClientFile,
  adminUploadClientFile,
  fetchArchivedAssetsCount,
  fetchClientAssetById,
  fetchClientAssetUsers,
  patchClientAssetUsersAccess,
} from 'hooks/client-asset-api';

export interface UseAdminClientFilesOperationsResult {
  uploadAdminClientFile: (
    args: AdminUploadClientFileArgs,
  ) => Promise<AssetDto>;
  patchAdminClientFile: (args: AdminPatchClientFileArgs) => Promise<AssetDto>;
  fetchAdminClientFile: typeof fetchClientAssetById;
  fetchAdminClientFileUsers: typeof fetchClientAssetUsers;
  patchAdminClientFileUsersAccess: typeof patchClientAssetUsersAccess;
  fetchAdminArchivedAssetsCount: typeof fetchArchivedAssetsCount;
}

export const useAdminClientFilesOperations =
  (): UseAdminClientFilesOperationsResult =>
    useMemo(
      (): UseAdminClientFilesOperationsResult => ({
        uploadAdminClientFile: adminUploadClientFile,
        patchAdminClientFile: adminPatchClientFile,
        fetchAdminClientFile: fetchClientAssetById,
        fetchAdminClientFileUsers: fetchClientAssetUsers,
        patchAdminClientFileUsersAccess: patchClientAssetUsersAccess,
        fetchAdminArchivedAssetsCount: fetchArchivedAssetsCount,
      }),
      [],
    );
